import React from 'react';
import {useEffect} from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Resume from './pages/Resume';
import LearningCardsPage from './pages/LearningCardsPage';
import GroupsPage from './pages/GroupsPage';
import GroupDetailPage from './pages/GroupDetailPage';
import TestPage from './pages/TestPage';
import { LEARNING_CARDS_ROUTES } from './constants/learning-cards';
import { WORDS } from './constants/words';

function App() {
    const location = useLocation();

    useEffect(() => {
        // На главной (резюме) держим тот же заголовок, что статически задан
        // в public/index.html — иначе краулеры и превью-боты получат общее «kosarev.app».
        document.title = location.pathname === '/' ? WORDS.RESUME_TITLE : WORDS.SITE_NAME;
    }, [location.pathname]);

    // На резюме (главной) свои шапка и блок контактов — общие Navbar и Footer прячем,
    // иначе внизу окажутся два одинаковых списка контактов подряд.
    const isResumePage = location.pathname === '/';

    return (
        <div className="d-flex flex-column min-vh-100">
            {!isResumePage && <Navbar />}
            <div className="main-container container-sm py-5 flex-grow-1">
                <Routes>
                    <Route path="/" element={<Resume />} />
                    <Route path="/home" element={<Home />} />

                    <Route path={LEARNING_CARDS_ROUTES.BASE} element={<LearningCardsPage />} />
                    <Route path={LEARNING_CARDS_ROUTES.GROUPS} element={<GroupsPage />} />
                    <Route path={LEARNING_CARDS_ROUTES.GROUP_DETAIL} element={<GroupDetailPage />} />
                    <Route path={LEARNING_CARDS_ROUTES.TEST} element={<TestPage />} />
                </Routes>
            </div>
            {!isResumePage && <Footer />}
        </div>
    );
}

export default App;